import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import { ProjectsActionTypes } from './types'
import { fetchError, fetchSuccess, fetchByNameSuccess, fetchByNameError } from './actions'
import { db } from '../../components/firebase'
import StringHelper from '../../utils/StringHelper'

import { ConvertBodyToPage, UpdateImages } from './saga-util-update'

// import project from '../../data/project.json'
// import events from '../../data/events.json'
// import blogs from '../../data/blog.json'
// import images from '../../data/images.json'
// import galleries from '../../data/imagegallery.json'
// import directories from '../../data/directories.json'
// import pages from '../../data/projects/2.json'

function FindPreviousItemPromise(item: any) {
  let promise = () =>
    db
      .FindPreviousProject(item.startDate, item.type)
      .get()
      .then(querySnapshot => querySnapshot.docs)
  return promise()
}
function FindNextItemPromise(item: any) {
  item = item == null ? 0 : item

  let promise = () =>
    db
      .FindNextProject(item.startDate, item.type)
      .get()
      .then(querySnapshot => querySnapshot.docs)
  return promise()
}

function updatePageData(projects: any) {
  projects.map(item => {
    if (item.data().id == 2) {
      db.GetProjectDoc(item.id)
        .update({
          pages: pages
        })
        .then(function() {
          console.log('Document successfully updated!')
        })
    }
  })
}
function* handleImage(id: number) {
  try {
    let promise = () =>
      db
        .findImage(id)
        .get()
        .then(snapshot =>
          snapshot.docs.map(doc => {
            return doc.data()
          })
        )
    const res = yield promise()
    yield put(fetchSuccess(res))
  } catch (err) {
    if (err instanceof Error) {
      yield put(fetchError(err.stack!))
    } else {
      yield put(fetchError('An unknown error occured.'))
    }
  }
}
// db.onceImages().add(events[0])
// galleries.map((o: any) => {
//   db.onceGalleries().add(o)
// })
function getProjectPromise(projectType: number) {
  let promise = () =>
    db
      .onceGetFirestoreProject(projectType)
      .get()
      .then(querySnapshot => querySnapshot.docs)
  return promise()
}

function getProjectPromiseByName(name: string, projectType: number) {
  let promise = () =>
    db
      .GetProjectByName(name, projectType)
      .get()
      .then(querySnapshot => querySnapshot.docs)
  return promise()
}

function getUsersPromise() {
  let promise = () =>
    db
      .onceUsers()
      .get()
      .then(querySnapshot => querySnapshot.docs)
  return promise()
}

function getImagesPromise() {
  let promise = () =>
    db
      .onceImages()
      .get()
      .then(querySnapshot => querySnapshot.docs)
  return promise()
}

function decorateUser(project: any, users: any) {
  // Consolidate - e.g. add author info
  project.map((item: any, index: number) => {
    // update author data if not there
    if (item.data().author == undefined) {
      // How do we update document with author details
      let u: any = users.find((user: any) => user.data().id == item.data().authorid)
      if (u != undefined) {
        // update item with author data
        db.GetProjectDoc(item.id)
          .update({
            author: {
              name: u.data().name,
              email: u.data().email,
              profile: u.data().profile
            }
          })
          .then(function() {
            console.log('Document successfully updated!')
          })
      }
    } else {
      console.log('author already defined')
    }
  })
}

function decorateImage(project: any, images: any) {
  // Consolidate - e.g. add author info
  const storageRef = db.storageRef()
  project.map((item: any, index: number) => {
    // update author data if not there
    if (item.data().cover == undefined) {
      // How do we update document with author details
      let u: any = images.find((image: any) => image.data().id == item.data().mainimage)
      if (u != undefined) {
        const image = storageRef.child(u.data().location.replace('~', ''))
        image.getDownloadURL().then(url => {
          console.log('url', url)
          // update item with author data
          db.GetProjectDoc(item.id)
            .update({
              cover: {
                description: u.data().description,
                location: u.data().location,
                id: u.data().id,
                url: url
              }
            })
            .then(function() {
              console.log('Document successfully updated!')
            })
        })
      }
    } else {
      console.log('cover already defined')
    }
  })
}

function* bulkUpdate(data: any) {
  console.log('bulkUpdate', data)
  let projectType: number = data == null ? 1 : data.payload
  const projects = yield getProjectPromise(projectType)
  // console.log(projects)

  for (let project of projects) {
    // console.log(project)
    // collect map of all body images to change
    // const result = yield call(updateURL, project)
    // const resultImg = yield call(updateImages, project)
  }
  // const results = yield all(calls)
  // yield put(fetchSuccess(results))
}
function* updateURL(item: any) {
  let name = item.data().name
  // console.log(name)
  name = StringHelper(name)
  // console.log(name)
  db.GetProjectDoc(item.id)
    .update({
      url_name: name
    })
    .then(function() {
      console.log(
        'updateURL ',
        item.data().name,
        item.data().url_name,
        name,
        ' successfully updated!'
      )
    })
}
function* updateImage(item: any) {
  const images = yield UpdateImages(item)

  images.map(item => {
    console.log('updateImage', item)
    db.GetProjectDoc(item.item.id)
      .update({
        body_old:
          item.item.data().body_old == null ? item.item.data().body : item.item.data().body_old,
        body: item.body
      })
      .then(function() {
        console.log('Document ' + item.item.name + ' successfully updated!')
      })
  })
}

function* updatePage(item: any, pages: any) {
  console.log('updatePage', item)
  console.log(pages)

  db.GetProjectDoc(item.id)
    .update(pages)
    .then(function() {
      console.log('Document ' + item.data().name + ' successfully updated!', item.data().id)
    })
}
function* updatePages(items: any) {
  for (let i = 0; i < items.length; i++) {
    const pages = yield ConvertBodyToPage(items[i])
    const page = yield updatePage(items[i], pages)
  }
}
function* handleFetch({ payload }) {
  try {
    let projectType: number = payload === undefined ? 1 : payload
    const res = yield getProjectPromise(projectType)
    // const pageresult = yield updatePages(res)

    // updatePageData(res)
    // const resUser = yield getUsersPromise()
    // const resImage = yield getImagesPromise()
    // decorateUser(res, resUser)
    // decorateImage(res, resImage)
    // decorateBody(res)
    // console.log(res)
    yield put(fetchSuccess(res.map(item => item.data())))
  } catch (err) {
    console.log(err)
    if (err instanceof Error) {
      yield put(fetchError(err.stack!))
    } else {
      yield put(fetchError('An unknown error occured.'))
    }
  }
}

function* handleFetchByName({ payload }) {
  try {
    let { projectType, name } = payload
    projectType = projectType === undefined ? 1 : projectType
    // console.log('handleFetchByName', name, projectType)
    const res = yield getProjectPromiseByName(name, projectType)

    // Update pages
    // if (res != null) {
    //   console.log('res', res[0])
    //   const imageRes = yield updateImage(res[0])
    //   const pages = yield ConvertBodyToPage(res[0])
    //   const page = yield updatePage(res[0], pages)
    // }
    // decorateUser(res, resUser)
    const resUser = yield getUsersPromise()
    let out = res.map(item => item.data())

    if (out[0] != undefined) {
      if (out[0].hasOwnProperty('url_name')) {
        // console.log('out[0]', out[0])
        const next = yield FindNextItemPromise(out[0])
        const previous = yield FindPreviousItemPromise(out[0])
        if (next[0] != null) out[0].next = next[0].data()
        if (previous[0] != null) out[0].previous = previous[0].data()
      }
      yield put(fetchByNameSuccess(out[0]))
    } else {
      yield put(fetchByNameError('no data found'))
    }
  } catch (err) {
    console.log(err)
    if (err instanceof Error) {
      yield put(fetchByNameError(err.stack!))
    } else {
      yield put(fetchByNameError('An unknown error occured.'))
    }
  }
}

function* bulkTransfer(data: any) {
  let projectType: number = data == null ? 1 : data.payload
  try {
    let promise = () =>
      db
        .onceGetFirestoreProject(projectType)
        .get()
        .then(querySnapshot => {
          let p: any = []
          querySnapshot.docs.map(doc => p.push(doc.data()))
          return p
        })
    const res = yield promise()
    yield put(fetchSuccess(res))
  } catch (err) {
    if (err instanceof Error) {
      yield put(fetchError(err.stack!))
    } else {
      yield put(fetchError('An unknown error occured.'))
    }
  }
}

function* watchBulkTransferRequest() {
  yield takeEvery(ProjectsActionTypes.BULK_TRANSFER, bulkTransfer)
}
// This is our watcher function. We use `take*()` functions to watch Redux for a specific action
// type, and run our saga, for example the `handleFetch()` saga above.
function* watchFetchRequest() {
  // console.log('watchFetchRequest', arguments)
  yield takeEvery(ProjectsActionTypes.FETCH_REQUEST, handleFetch)
}
function* watchFetchByNameRequest() {
  // console.log('watchFetchByNameRequest', arguments)
  yield takeEvery(ProjectsActionTypes.FETCH_BY_NAME_REQUEST, handleFetchByName)
}

function* watchBulkUpdate() {
  // console.log('watchBulkRequest ', arguments)
  yield takeEvery(ProjectsActionTypes.BULK_UPDATE, bulkUpdate)
}
// We can also use `fork()` here to split our saga into multiple watchers.
function* ProjectsSaga() {
  yield all([
    fork(watchFetchRequest),
    fork(watchFetchByNameRequest),
    fork(watchBulkUpdate),
    // fork(watchFetchRequestByName),
    fork(watchBulkTransferRequest)
  ])
}

export default ProjectsSaga
